import { useQuery } from "@tanstack/react-query";
import type { CatalogDelayCode } from "../../codes/models/CatalogDelayCode";
import { getDelayCode } from "../../codes/repositories/ConfigurationDelayRepository";

export const useDelayCodeQuery = (
  delayCodeId: number | null | undefined,
  enabled = true,
) => {
  return useQuery({
    queryKey: ["delay-code", delayCodeId],
    queryFn: async ({ signal }) => {
      const resp = await getDelayCode(delayCodeId!, signal);
      if (resp.ok) {
        return (resp.data?.tables?.[0]?.rows?.[0] ??
          null) as CatalogDelayCode | null;
      }
      throw new Error(resp.message);
    },
    enabled: enabled && !!delayCodeId,
  });
};
